import { useState, useEffect } from "react";
import Button from "src/components/Button";
import DialogComponent from "../../../components/DialogComponent";
import { useAppSelector } from "src/hooks/redux";
import { selectItem } from "src/modules/spItems/selectors";
import { myDocumentsListName } from "src/api/config";

type Props = {
    open: boolean;
    toggleDialog: (b: boolean) => void;
    setOpen: (b: boolean) => void;
    setShowEditApprovers: any;
    showEditApprovers: any;
    card: any;
}

function ArchiveEndModal(props: Props) {

    const { open, toggleDialog, setOpen, showEditApprovers, setShowEditApprovers, card } = props;

    return (
        <DialogComponent open={open} toggleDialog={toggleDialog}>
            <div className="aarchiveEndModal">
                <span className="block text-[24px] mb-[18px] leading-7.5 font-semibold">Разархивация документа</span>
                <span className="block text-[16px] leading-[22px] mb-[38px]">Вы уверены, что хотите разархивировать документ<br /> «{card.Title}»?<br /> После разархивации документ будет отправлен на согласование.</span>
                <div className="divide-y mb-[40px] h-px border-t" />
                <div className="flex justify-between">
                    <div className="mr-5">
                        <Button
                            classBg="btn-white"
                            shadow={true}
                            text="Отмена"
                            open={open}
                            setOpen={setOpen}
                        />
                    </div>
                    <div className="ml-5">
                        <Button
                            open={open}
                            setOpen={setOpen}
                            classBg="btn-dark"
                            text="Разархивировать"
                            customFunction={setShowEditApprovers}
                            paramsCustomFunction={!showEditApprovers}
                        />
                    </div>
                </div>
            </div>
        </DialogComponent>
    );
}

export default ArchiveEndModal;



